import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { HttpHeaderConstants } from '@r1-compass-library/constants';
import { Play } from '@r1-compass-library/models';
import { ErrorHandlingService } from '@r1-compass-library/services/error-handling.service';
import { Observable, catchError, finalize, retry } from 'rxjs';
import { Environment } from '@r1-compass-library/environments/environment';
import { PlayQueryResult } from '../../../../models/play-query.model';
import { SpinnerService } from '@r1-compass-library/services/spinner.service';

@Injectable({
    providedIn: 'root',
})
export class QueryService {
    readonly #http = inject(HttpClient);
    readonly #spinnerService = inject(SpinnerService);
    readonly #errorHandlingService = inject(ErrorHandlingService);

    private BASE_URL: string = Environment.baseUrl + '/frontend/play-query';

    getCountsQuery(play: Play, templateCriteriaId?: number): Observable<PlayQueryResult> {
        const httpOptions = {
            headers: new HttpHeaders({ ...HttpHeaderConstants.defaultHeaders }),
        };

        const process = 'QueryService.getCountsQuery';
        this.#spinnerService.addProcess(process, 'Getting counts query...');
        return this.#http
            .post<PlayQueryResult>(
                `${this.BASE_URL}/counts?playId=${play.id}&templateCriteriaId=${templateCriteriaId}`,
                play.config,
                httpOptions
            )
            .pipe(
                retry(0),
                catchError(error => {
                    return this.#errorHandlingService.handleApiError(error);
                }),
                finalize(() => this.#spinnerService.completeProcess(process))
            );
    }

    getSegmentationQuery(play: Play, templateCriteriaId?: number): Observable<PlayQueryResult> {
        const httpOptions = {
            headers: new HttpHeaders({ ...HttpHeaderConstants.defaultHeaders }),
        };

        const process = 'QueryService.getSegmentationQuery';
        this.#spinnerService.addProcess(process, 'Getting segmentation query...');
        return this.#http
            .post<PlayQueryResult>(
                `${this.BASE_URL}/segmentation?playId=${play.id}&templateCriteriaId=${templateCriteriaId}`,
                play.config,
                httpOptions
            )
            .pipe(
                retry(0),
                catchError(error => {
                    return this.#errorHandlingService.handleApiError(error);
                }),
                finalize(() => this.#spinnerService.completeProcess(process))
            );
    }
}
